module.exports = __webpack_public_path__ + "static/KIN3-0446fbf5edcc5293e088f16476db2906.jpg";